export default function($stateProvider) {
    $stateProvider
        .state('cjenik', {
            url: '/cjenik',
            component: 'cjenik',
        })
        .state('cjenik.details', {
            url: '/:id',
            views: {
                '@' : {
                    component: 'stavkaCjenika',
                }
            },
            resolve: {
                cjenik: ['$transition$', 'DS', function($transition$, DS) {
                    const params = $transition$.params();
                    return DS.find('Cjenik', params.id);
                }]
            }
        });
}



// WEBPACK FOOTER //
// ./app/components/cjenik/states.js